<div class="team-timesheet-metrics">
  <div class="header">
    <div class="title-block">
      <div class="title-row">
        <emerald-icon
          icon="schedule"
          color="#003F2D"
          type="outlined"
        ></emerald-icon>
        <h3 class="title">
          <button type="button" class="title-button" (click)="navigateToTimesheet()">
            Timesheet Metrics
          </button>
        </h3>
        <emerald-icon
          [icon]="'open_in_new'"
          [color]="priority.grey"
          role="button"
          tabindex="0"
          (click)="navigateToTimesheet()"
          (keydown.enter)="navigateToTimesheet()"
          (keydown.space)="navigateToTimesheet()"
        ></emerald-icon>
      </div>
      <div class="header-stats" *ngIf="!loadError && !loading && totalContractors > 0">
        <span class="stat"><span class="stat-value">{{ totalContractors }}</span><span class="stat-label">contractors</span></span>
        <span class="stat-divider"></span>
        <span class="stat"><span class="stat-value">{{ approvalRate }}%</span><span class="stat-label">approval rate</span></span>
      </div>
    </div>
    <select
      class="month-select"
      aria-label="Month"
      [ngModel]="selectedMonthKey"
      (ngModelChange)="onMonthChange($event)"
    >
      <option *ngFor="let m of monthOptions" [ngValue]="m.label">{{ m.label }}</option>
    </select>
  </div>

  <div class="tiles" *ngIf="!loadError">
    <div class="tile" *ngFor="let tile of tiles" [attr.data-tone]="tile.tone">
      <div class="tile-value">{{ loading ? '—' : tile.value }}</div>
      <div class="tile-label">{{ tile.label }}</div>
    </div>
  </div>

  <div class="chart-wrapper" *ngIf="!loadError; else errorState">
    <ng-container *ngIf="!loading && chartData?.labels?.length; else emptyState">
      <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
    </ng-container>
    <ng-template #emptyState>
      <div class="empty">
        <span *ngIf="loading">Loading…</span>
        <span *ngIf="!loading">No timesheet data.</span>
      </div>
    </ng-template>
  </div>

  <ng-template #errorState>
    <div class="error">Unable to load timesheet metrics.</div>
  </ng-template>
</div>
